import VehicleExit from './VehicleExit';

export default VehicleExit;